module.exports = __webpack_public_path__ + "img/credit-card-front.4da414e9.svg";